import { AdminEventJourneyStepType, EventSource, VenueEventVisibility } from '@ivy-monorepo/shared'

export const EVENT_SOURCE_LABELS: Record<EventSource, string> = {
  [EventSource.Hotspot]: 'Hotspot',
  [EventSource.EventList]: 'Event list',
  [EventSource.Spotlight]: 'Spotlight',
  [EventSource.Push]: 'Push',
  [EventSource.Other]: 'Other',
}

/** Null = the app build did not report a source (released before source tracking). */
export const formatEventSource = (source: EventSource | null | undefined): string => (source ? (EVENT_SOURCE_LABELS[source] ?? source) : 'Not reported')

export const JOURNEY_STEP_LABELS: Record<AdminEventJourneyStepType, string> = {
  [AdminEventJourneyStepType.HotspotModalShown]: 'Hotspot modal auto-opened',
  [AdminEventJourneyStepType.HotspotCardTapped]: 'Tapped hotspot card',
  [AdminEventJourneyStepType.HotspotCtaTapped]: 'Tapped hotspot CTA',
  [AdminEventJourneyStepType.GetTicketsTapped]: 'Tapped "Get a Ticket"',
  [AdminEventJourneyStepType.Rsvp]: 'RSVP',
  [AdminEventJourneyStepType.TicketPurchase]: 'Ticket purchase',
}

export const formatJourneyDate = (iso: string | null | undefined): string => (iso ? new Date(iso).toLocaleString() : '—')

/** "Active" / "Inactive", plus "Internal only" for events hidden from regular users. */
export const formatEventStatus = (isActive: boolean, visibility?: VenueEventVisibility | null): string =>
  `${isActive ? 'Active' : 'Inactive'}${visibility === VenueEventVisibility.InternalOnly ? ' · Internal only' : ''}`
